import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { RouterModule, Routes } from '@angular/router';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { InnerHeaderModule } from 'src/app/inner-header/inner-header.module';
import { InnerFooterModule } from 'src/app/inner-footer/inner-footer.module';
import { TabsModule } from 'ngx-bootstrap/tabs';



const routes : Routes =  [
  {
      path     : '',
      component: HomeComponent,
  }
];


@NgModule({
  declarations: [
    HomeComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    AccordionModule,
    InnerHeaderModule,
    InnerFooterModule,
    TabsModule.forRoot(),
  ]
})
export class HomeModule { }
